export default "__VITE_ASSET__aeed3c91__"